import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, Form, Modal, Input } from 'antd'
import { createStructuredSelector } from 'reselect'
import { selectStaff, selectedStaffData } from 'redux/staff/selectors'
import StaffAction from 'redux/staff/actions'

const { TextArea } = Input

const mapStateToProps = () =>
  createStructuredSelector({
    staff: selectStaff,
    selectedStaff: selectedStaffData,
  })

const ChangeAccountManager = ({
  visible,
  staff,
  onCancel,
  loading,
  title,
  intl: { formatMessage },
}) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const onSubmit = values => {
    dispatch({
      type: StaffAction.SEND_BIRTHDAY_GREETINGS,
      payload: {
        userId: staff?.selectedData?.id,
        message: values?.message,
      },
    })
  }

  return (
    <Modal title={title} visible={visible} onCancel={onCancel} footer={null}>
      <Form
        form={form}
        layout="vertical"
        initialValues={{ options: 'Update' }}
        hideRequiredMark
        onFinish={onSubmit}
      >
        <Form.Item
          name="message"
          label={formatMessage({ id: 'form.label.message' })}
          rules={[{ required: true, message: formatMessage({ id: 'form.error.required' }) }]}
        >
          <TextArea
            size="large"
            style={{ width: '650px', resize: 'none' }}
            rows="5"
            placeholder="Message"
          />
        </Form.Item>
        <Form.Item className="text-right">
          <Button type="primary" htmlType="submit" size="large" loading={loading}>
            {formatMessage({ id: 'action.Update' })}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default connect(mapStateToProps)(injectIntl(ChangeAccountManager))
